import { FC } from "react";
import { SidebarLinkTypes } from "../LinkTypes";
import { SuperAdminComplexLink } from "./SideBarComponents/SuperAdminComplexLink";
import { DocumentManagementComplexLink } from "./SideBarComponents/DocumentManagementComplexLink";
import { ConfigurationComplexLink } from "./SideBarComponents/ConfigurationComplexLink";
import { IncentivationComplexLink } from "./SideBarComponents/IncentivationComplexLink";
import { AnalysisFilesComplexLink } from "./SideBarComponents/AnalysisFilesComplexLink";
import { WalletComplexLink } from "./SideBarComponents/WalletComplexLink";

interface ComplexSidebarLinkProps {
  linkName: SidebarLinkTypes;
  activePathname: string;
  collapsed?: boolean;
  showText?: boolean;
  submenuLinks?: string[];
}

const ComplexSidebarLink: FC<ComplexSidebarLinkProps> = ({
  linkName,
  activePathname,
  collapsed = false,
  showText = true,
  submenuLinks = [],
}) => {
  switch (linkName) {
    case SidebarLinkTypes.incentivation:
      return <IncentivationComplexLink activePathname={activePathname} collapsed={collapsed} showText={showText} />;
    case SidebarLinkTypes.wallet:
      return <WalletComplexLink activePathname={activePathname} collapsed={collapsed} showText={showText} />;
    case SidebarLinkTypes.documentManagement:
      return <DocumentManagementComplexLink activePathname={activePathname} collapsed={collapsed} showText={showText} submenuLinks={submenuLinks} />;
    case SidebarLinkTypes.analysisFiles:
      return <AnalysisFilesComplexLink activePathname={activePathname} collapsed={collapsed} showText={showText} />
    case SidebarLinkTypes.configuration:
      return <ConfigurationComplexLink activePathname={activePathname} collapsed={collapsed} showText={showText} submenuLinks={submenuLinks} />;
    case SidebarLinkTypes.superAdmin:
      return <SuperAdminComplexLink activePathname={activePathname} collapsed={collapsed} showText={showText} />;
    default:
      return <></>;
  }
};

export default ComplexSidebarLink;
